module.exports = __webpack_public_path__ + "3f6943725cfb8cdc9a7ff2deb76c07ed.svg";